<template>
    <o-table :title="$t('sandoz.item_classification')" ref="tableList" url="/api/sandoz/item_classifications" :enable-delete="false" :enable-new="false" :enable-edit="false">
        <template slot="filter">
            <div class="row">
                <div class="col">
                    <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                        <o-filter-text :title="$t('sandoz.item_name')" column="item_name"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.classification')" column="classification"></o-filter-text>
                    </o-filter>
                </div>
                <div class="col text-right" style="flex: 0 0 580px;">
                  <b-overlay :show="showItemClassification" rounded="sm" class="d-inline-block">
                    <b-dropdown split :text="$t('sandoz.download_item_classification')" @click.prevent="itemClassificationXlsx()">
                      <b-dropdown-item @click.prevent="uploadItemClassification">{{$t('sandoz.upload_item_classification')}}</b-dropdown-item>
                    </b-dropdown>
                  </b-overlay>
                  <b-overlay :show="showItemReport" rounded="sm" class="d-inline-block">
                    <b-button type="button" variant="secondary" @click.prevent="itemReportXlsx()">
                      {{ $t('sandoz.download_classified_contract_items') }}
                    </b-button>
                  </b-overlay>
                  <input type="file" ref="fileSelector" class="d-none" @change="fileSelected">
                </div>
            </div>
        </template>
        <template slot="head">
            <o-table-header column="item_name">{{$t('sandoz.item_name')}}</o-table-header>
            <o-table-header column="classification">{{$t('sandoz.classification')}}</o-table-header>
            <o-table-header column="marketing_services_type">{{$t('sandoz.marketing_services_type')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.item_name }}</td>
            <td>{{ props.item.classification }}</td>
            <td>{{ props.item.marketing_services_type }}</td>
        </template>
    </o-table>
</template>

<script>
    import axios from 'axios'

    export default {
        data: () => ({
          showItemClassification: false,
          showItemReport: false
        }),
        created() {

        },
        mounted() {
        },
        methods: {
            uploadItemClassification() {
                this.$refs.fileSelector.click()
            },
            fileSelected(evt) {
              const reader = new FileReader()
              const file = evt.target.files[0]
              var self = this

              reader.addEventListener(
                "load",
                () => {
                  self.showItemClassification = true
                  axios.post('/api/sandoz/item_classifications/upload-item-classification-excel', { data: reader.result }).then(response => {
                      self.$notify({
                          title: self.$i18n.t('sandoz.item_classification_imported'),
                          text: self.$i18n.t('sandoz.item_classification_imported'),
                          type: 'info'
                      })
                      self.showItemClassification = false
                  }).catch((error) => {
                      self.$notify({
                          title: self.$i18n.t('core.error_alert_title'),
                          text: self.$i18n.t('core.error_alert_text'),
                          type: 'error'
                      })
                      self.showItemClassification = false
                  })
                },
                false
              );

              if (file) {
                reader.readAsDataURL(file)
              }
            },
            itemReportXlsx() {
                var self = this
                self.showItemReport = true
                axios.post('/api/sandoz/item_classifications/item-report-excel', { }, { responseType: 'arraybuffer' })
                  .then((response) => {
                      require('downloadjs')(response.data, 'item_report.xlsx', 'application/vnd.ms-excel')
                      self.showItemReport = false
                  }).catch((error) => {
                      self.$notify({
                          title: self.$i18n.t('core.error_alert_title'),
                          text: self.$i18n.t('core.error_alert_text'),
                          type: 'error'
                      })
                      self.showItemReport = false
                  })
            },
            itemClassificationXlsx() {
                var self = this
                self.showItemClassification = true
                axios.post('/api/sandoz/item_classifications/item-classification-excel', { }, { responseType: 'arraybuffer' })
                  .then((response) => {
                      require('downloadjs')(response.data, 'item_classification.xlsx', 'application/vnd.ms-excel')
                      self.showItemClassification = false
                  }).catch((error) => {
                      self.$notify({
                          title: self.$i18n.t('core.error_alert_title'),
                          text: self.$i18n.t('core.error_alert_text'),
                          type: 'error'
                      })
                      self.showItemClassification = false
                  })
            }
        }
    }
</script>
